export default __webpack_public_path__ + "static/media/offices2.b9c94410.png";